import React from "react";
import Header from "../Header";
import { Spin } from "antd";

export default function CourseSpin() {
    return (
        <div>
            <Header />

            <Spin>
                <div style={{ textAlign: "center", height: 400 }} />
            </Spin>
        </div>
    );
}
